module.exports = __webpack_public_path__ + "static/media/200706-artwork-fashion-slashie-theo.f0c25bf8.jpg";